var _path, _rect, _rect2, _line, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.25L5.05884 3.62866C5.43464 3.33272 5.62254 3.18475 5.83033 3.21113C6.03811 3.23752 6.18306 3.42777 6.47296 3.80826L7.52704 5.19174C7.81694 5.57223 7.96189 5.76248 8.16967 5.78887C8.37746 5.81525 8.56536 5.66728 8.94116 5.37134L11 3.75",
    stroke: "#323743",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 13,
    stroke: "#323743"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6.5,
    width: 4,
    height: 4,
    rx: 2,
    stroke: "#323743"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 14,
    x2: 6.5,
    y2: 16,
    stroke: "#323743"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 14,
    x2: 13.5,
    y2: 16,
    stroke: "#323743"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16.5,
    x2: 16,
    y2: 16.5,
    stroke: "#323743"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 8.5,
    x2: 10,
    y2: 8.5,
    stroke: "#323743"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10.5,
    x2: 8,
    y2: 10.5,
    stroke: "#323743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.f6aba3a238fa79d8d4691c3263734f8a.svg";
export { ForwardRef as ReactComponent };